module.exports = __webpack_public_path__ + "static/hero-top-3-sp-85d4880d7a68b945a08db9dce532aa6b.png";